<template>
  <div class="vuser-account17-storage-plans">
    <div class="vuser-account17-storage-plan current">
      <div class="vuser-account17-storage-title">{{$vt('Storage plan')}}</div>

      <div
        class="vuser-account17-storage-plan-bytes"
        v-html="$options.filters.angularFilter(storageCost.size, 'bytesHtml')"
      ></div>
      <div
        class="vuser-account17-storage-plan-limit"
        v-html="$options.filters.angularFilter(plan.limit, 'bytesHtml')"
      ></div>

      <f-progress-bar
        class="vuser-account17-storage-plan-progressbar"
        :progress="storageCost.size / plan.limit"
      ></f-progress-bar>

      <div class="vuser-account17-storage-plan-cost" v-if="plan.cost == 0">
        {{$vt('Free')}}
      </div>
      <div class="vuser-account17-storage-plan-cost" v-if="plan.cost > 0">
        {{ plan.cost }} {{$vt('credits/month')}}
      </div>

    </div>
    
      <f-link target="_blank" href="https://www.vodalys.io/fr/conditions-generales-dutilisation/">{{$vt('Terms & Pricing')}}</f-link>
  </div>
</template>
<script>
export default {
  props: {
    storageCost: Object,
  },
  mounted() {
    console.warn("storageCost", this.storageCost);
  },
  computed: {
    plan() {
      return (
        this.storageCost?.plans?.[this.storageCost?.plan_nid] ??
        this.storageCost?.plans?.[Object.keys(this.storageCost?.plans)[0]]
      );
    },
  },
};
</script>
<style lang="scss">
.vuser-account17-storage-plans {
  background-color: var(--white-a10);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .vuser-account17-storage-plan {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto auto;
    column-gap: 8px;
    row-gap: 8px;
  }

  .vuser-account17-storage-plan.not-current {
    row-gap: 0;
  }

  .vuser-account17-storage-title {
    grid-row: 1/2;
    grid-column: 1/2;
    font-weight: bold;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
  }

  .vuser-account17-storage-icon {
    grid-row: 1/2;
    grid-column: 1/2;
    color: var(--turquoise);
    display: flex;

    .f-icon {
      font-size: 12px;
    }
  }

  .vuser-account17-storage-plan-bytes {
    grid-row: 2/3;
    grid-column: 1/2;
    font-weight: bold;
  }

  .vuser-account17-storage-plan-limit {
    grid-row: 2/3;
    grid-column: 3/4;
    font-weight: 700;
  }

  .current {
    .vuser-account17-storage-plan-limit {
      justify-self: end;
    }

    .vuser-account17-storage-plan-cost {
      justify-self: end;
    }
  }

  .not-current {
    border: 1px solid rgba(22, 22, 21, 0.1);
    border-radius: 6px;
    padding: 8px;

    .vuser-account17-storage-plan-limit {
      grid-row: 1/2;
      grid-column: 2/3;
      color: rgba(22, 22, 21, 0.5);
      justify-self: start;
    }

    .vuser-account17-storage-plan-cost {
      color: var(--primary);
      grid-row: 2/3;
      grid-column: 2/3;
      background: none;
      padding: 0;
      font-weight: 500;
      justify-left: start;
    }
  }

  .vuser-account17-storage-plan-progressbar {
    grid-row: 3/4;
    grid-column: 1/4;
  }

  .vuser-account17-storage-plan-cost {
    grid-row: 1/2;
    grid-column: 3/4;
    background-color: var(--primary);
    padding: 4px 8px;
    border-radius: 4px;
    color: var(--black);
    font-weight: 700;
  }
}
</style>